import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TeamService, TeamItem } from '../../../../services/team/team.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SpinnerComponent } from "src/app/components/layout/spinner/spinner.component";
import { UploadComponent } from "src/app/components/layout/file-manager/upload/upload.component";
import { EditorModule } from '@tinymce/tinymce-angular';
import 'tinymce/tinymce.min.js';                    
import 'tinymce/icons/default/icons.min.js';
import 'tinymce/themes/silver/theme.min.js'; 

// საჭიროებისამებრ პლაგინები
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/fullscreen';
@Component({
  selector: 'app-team-modal',
  imports: [CommonModule, FormsModule, SpinnerComponent, UploadComponent, EditorModule],
  templateUrl: './team-modal.component.html',
  styleUrl: './team-modal.component.css'
})
export class TeamModalComponent {
  @Input() lang: 'geo' | 'eng' | 'rus' = 'geo';
  @Input() itemId?: number;

  loading = false;

  model: Partial<TeamItem> = {
    lang: 'geo',
    page: 0,
    name: '',
    work_position: '',
    image: '',
    content: '',
    linkedin: '',
    facebook: '',
    gmail: '',
    candidat: '',
    archevnebi: '',
    birthday: '',
    phone: '',
    visible: 1,
  };

  

  constructor(
    public activeModal: NgbActiveModal,
    private teamService: TeamService
  ) {}

  ngOnInit() {
    this.model.lang = this.lang;

    if (this.itemId) {
      this.loading = true;
      this.teamService.getOne(this.itemId, this.lang).subscribe({
        next: (res) => {
          this.model = { ...this.model, ...(res?.data || {}) };
          this.model.lang = this.lang;
          this.loading = false;
        },
        error: () => (this.loading = false)
      });
    }
  }

  getTeamUploadPath(): string {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `res/team/${yyyy}/${mm}`;
  }

  onFileUploaded(res: any) {
    const path = res?.new?.path || res?.path || res?.data?.path || res?.file?.path;
    const url = res?.new?.url || res?.url || res?.data?.url;

    if (typeof path === 'string' && path.length) {
      this.model.image = path;
      return;
    }

    if (typeof url === 'string' && url.length) {
      this.model.image = url
        .replace(/^https?:\/\/[^/]+\/(storage\/)?/i, '')
        .replace(/^storage\//i, '');
    }
  }

  // getImagePreviewUrl(): string {
  //   const img = (this.model.image || '').trim();
  //   if (!img) return '';
  //   if (/^https?:\/\//i.test(img)) return img;
  //   return `https://api.sca.ge/storage/${img.replace(/^\/+/, '')}`;
  // }

  getImagePreviewUrl(): string {

    const raw = (this.model.image || '').trim();
    if (!raw) return '';

    // Old absolute URLs like https://api.sca.ge/storage/res/...
    // should now be served through Laravel route: /api/media/...
    if (raw.startsWith('http://') || raw.startsWith('https://')) {
      try {
        const url = new URL(raw);
        if (url.hostname === 'api.sca.ge' && url.pathname.startsWith('/storage/')) {
          const cleanPath = url.pathname.replace(/^\/storage\//, '');
          return `https://api.sca.ge/api/media/${cleanPath}`;
        }
        return raw;
      } catch {
        return raw;
      }
    }

    // Relative path like res/list/2026/03/file.webp
    const cleanPath = raw.replace(/^\/+/, '');
    return `https://api.sca.ge/api/media/${cleanPath}`;
  }

  save() {
    if (!this.model.name?.trim()) {
      alert('სახელი სავალდებულოა');
      return;
    }

    this.loading = true;

    if (this.itemId) {
      this.teamService.update(this.itemId, this.model, this.lang).subscribe({
        next: () => {
          this.loading = false;
          this.activeModal.close(true);
        },
        error: () => (this.loading = false)
      });
    } else {
      this.teamService.create(this.model).subscribe({
        next: () => {
          this.loading = false;
          this.activeModal.close(true);
        },
        error: () => (this.loading = false)
      });
    }
  }
}
